var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{attrs:{"form":_vm.form,"rules":_vm.rules,"label-width":_vm.label_width}},_vm._l((_vm.forms),function(item,index){return _c('el-col',{key:index,attrs:{"lg":5,"md":12,"sm":12,"xl":5}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }